export default {
    billingTerms: {
        helpText: '（月払のみの取扱いのため変更はできません。）',
        monthly: '月払',
        yearly: '年払',
        yearlyWithTwoMonthsFree: '年払 <0>2ヶ月分割引</0>',
    },
    checkboxes: {
        app: {
            akinaiBugyoIntegration: '商奉行連携',
            customCsvIntegration: 'カスタムCSVインポート',
            ipAddressRestriction: 'IPアドレス制限',
            kanjoBugyoIntegration: '勘定奉行連携',
            kintoneIntegration: 'kintone連携',
            pcaDxIntegration: 'PCA会計DX連携 ',
            pdfImporterIntegration: 'PDF一括送付',
            shokonIntegration: 'PCA商魂DX連携',
            voucherStorageIntegration: 'RICOH 証憑電子保存サービス連携',
        },
        options: {
            customDomain: 'メールドメイン指定',
            ml4sf: 'MakeLeaps for Salesforce',
            rakutenVa: 'バーチャル口座',
        },
    },
    enterprise: {
        clientsHelpText: '無制限',
        description:
            '基本料金でメンバー数、取引先数も無制限累計取引社数やユーザー数が多い大企業様でも安心してシステム導入が可能',
        sendingOrders: '送付依頼',
        sendingOrdersHelpText:
            '月々300通まで無料、それ以上は送付依頼した通数に応じて30円/通の費用が発生します。（別途郵送代行は所定の費用がかかります。）貴社のご予算に合わせて送付依頼できる通数の上限を設定することが可能です。（いつでもこの画面から変更可能）',
        sendingOrdersLimit:
            '送付依頼の上限通数（今月すでに{{value}}通送付依頼済み）',
        teamMembersHelpText: '無制限',
    },
    individual: {
        description:
            'メンバー3名、取引先10社まで全書類タイプが作成管理できて、月々500円〜',
        teamMembersHelpText: '500円/メンバー/月',
        warning: '3名以上のメンバーが必要な場合、法人プランをご検討ください。',
    },
    organization: {
        clientsHelpText: '10社まで無料、それ以上は<0>取引先数に応じます。</0>',
        description:
            'ご利用シーンに合わせてメンバー、取引先を追加他部署と情報共有、協力して更に効率的な請求作業を',
        options: 'オプション <0>(プランの詳細をみる)</0>',
        teamMembersHelpText: '800円/メンバー/月',
    },
    shared: {
        activeClients: '取引先数／書類の宛先数',
        billingDetails: 'プランの詳細',
        billingFrequency: '支払い頻度',
        billingFrequencyHelpText:
            '（月払のみの取扱いのため変更はできません。）',
        buyMailPoints: '郵送ポイントの購入',
        changeSubscription: 'プランの変更',
        enterprise: 'エンタープライズプラン',
        error: 'エラー',
        findOutMore: 'プランの詳細をみる',
        freeForLimitedTime:
            '<0>制限付きの無料プラン</0>有り。<1>NPO団体向けの20％割引プラン</1>については別途お問い合わせください。',
        individual: '個人プラン',
        integrations: 'アプリ連携',
        loading: 'ロード',
        options: 'オプション <0>(プランの詳細をみる)</0>',
        organization: '法人プラン',
        plusTax: '{{value}}（税抜）',
        pricePerMonth: '({{value}}／月)',
        subscribe: ' 次へ（確認画面） ',
        teamMembers: 'メンバー数',
    },
};
